import Vue from "vue";
import VueRouter from "vue-router";
import Properties from "../views/Properties.vue";
import GuestData from "../views/GuestData.vue";
import Feedbacks from "../views/Feedbacks.vue";
import MyAccount from "../views/MyAccount.vue";
import Users from "../views/admin/Users.vue";
import User from "../views/admin/User.vue";
import XUsers from "../views/admin/XUsers.vue";
import EmailToSend from "../views/admin/EmailToSend.vue";
import Support from "../views/Support.vue";
import HowToVideos from "../views/HowToVideos.vue";
import Organizations from "../views/admin/Organizations.vue";
import Organization from "../views/admin/Organization.vue";
import adminSettings from "../views/admin/adminSettings.vue";
import PropertyTemplates from "../views/admin/PropertyTemplates.vue";
import Analytics from "../views/admin/Analytics.vue";
import AnalyticsAPI from "../../analytics_api.vue";
import AllProperties from "../views/admin/AllProperties.vue";
import AdvancedAnalytics from "../views/admin/AdvancedAnalytics.vue";
import Interview from "../views/Interview.vue";
import Property from "../views/Property.vue";
import BackgroundImages from "../views/BackgroundImages.vue";

import UpdatesLog from "../views/admin/UpdatesLog.vue";
import TaskManager from "../views/TaskManager.vue";
// import Firebase from 'firebase'

// import store from '../store'

Vue.use(VueRouter);

const routes = [
  {
    path: "/properties",
    redirect: "/",
  },
  {
    path: "/",
    name: "Properties",
    component: Properties,
    meta: {
      requiresAuth: true,
      hideTopSearch: true,
    },
  },

  // {
  //   path: "/welcome",
  //   name: "Welcome",
  //   component: Welcome,
  //   meta: {
  //     requiresAuth: false
  //   },
  // },
  {
    path: "/guestdata",
    name: "GuestData",
    component: GuestData,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/feedbacks",
    name: "Feedbacks",
    component: Feedbacks,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/myaccount",
    component: MyAccount,
  },
  {
    path: "/users",
    component: Users,
    meta: {
      hideTopSearch: true,
    },
  },
  {
    path: "/user/:id",
    name: "user",
    component: User,
  },
  {
    path: "/xusers",
    component: XUsers,
  },
  {
    path: "/organizations",
    component: Organizations,
    meta: {
      hideTopSearch: true,
    },
  },
  {
    path: "/adminSettings",
    component: adminSettings,
  },
  {
    path: "/templates",
    name: "PropertyTemplates",
    component: PropertyTemplates,
    meta: {
      requiresAuth: true,
      hideTopSearch: true,
    },
  },
  {
    path: "/organization/:id",
    name: "organization",
    component: Organization,
  },
  {
    path: "/emailtosend",
    component: EmailToSend,
  },
  {
    path: "/support",
    component: Support,
  },
  {
    path: "/support/how-to-videos",
    name: "HowToVideos",
    component: HowToVideos,
  },
  {
    path: "/updateslog",
    component: UpdatesLog,
  },
  {
    path: "/allproperties",
    component: AllProperties,
    meta: {
      hideTopSearch: true,
    },
  },
  {
    path: "/property/:propertyId",
    component: Property,
  },
  {
    path: "/analytics",
    component: Analytics,
  },
  {
    path: "/analytics_api",
    component: AnalyticsAPI,
  },
  {
    path: "/advancedanalytics",
    component: AdvancedAnalytics,
    meta: {
      hideTopSearch: true,
    },
  },
  {
    path: "/interview/:propertyId",
    component: Interview,
  },
  {
    path: "/interview/",
    component: Interview,
  },
  {
    path: "/backgroundimages",
    component: BackgroundImages,
  },
  {
    path: "/tasks",
    component: TaskManager,
  },
  {
    path: "/subscribe",
    redirect: "/premium",
  },
  {
    path: "/premium",
    component: () => import("../views/Premium.vue"),
  },
  {
    path: "/upgrade",
    component: () => import("../views/Upgrade.vue"),
  },
  {
    path: "/premium-success",
    component: () => import("../views/Premium-success.vue"),
  },
  {
    path: "/premium-cancel",
    component: () => import("../views/Premium-cancel.vue"),
  },
  {
    path: "/terms",
    component: () => import("../views/Terms.vue"),
  },
  {
    path: "/privacy",
    component: () => import("../views/Privacy.vue"),
  },
  {
    path: "/auth/action",
    name: "AuthAction",
    component: { render: (h) => h("div") },
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/storage-images",
    component: () => import("../views/StorageImages.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/admin/email-template",
    component: () => import("../views/admin/EmailTemplateEditor.vue"),
  },
  {
    path: "/admin/reactivation-promo",
    component: () => import("../views/admin/ReactivationPromoSend.vue"),
    meta: {
      hideTopSearch: true,
    },
  },
  {
    path: "/admin/published-properties-emails",
    component: () => import("../views/admin/PublishedPropertiesEmails.vue"),
  },
  {
    path: "/admin/subscription-strategy",
    component: () => import("../views/admin/SubscriptionLaunchStrategy.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach( (to, from, next) => {
//   const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
//   console.log("requiresAuth",requiresAuth)
//   const currentUser = store.getters.user
//   console.log('currentUser',currentUser)

//   if (requiresAuth && !currentUser) next({ path: '/signin'})
//   else if (!requiresAuth && currentUser) next()
//   else if (!requiresAuth && !currentUser) next()
//   else next()
// })

// router.beforeEach( (to, from, next) => {
//   const currentUser = store.getters.user
//   const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
//   console.log('currentUser',currentUser)
//   console.log('currentUser', !currentUser )
//   console.log(to.name)
//   if (!currentUser && requiresAuth) next({ path: '/signin'})
//   else next()
// })

//Tried all these authguards - some did not register authentication soon enough
// router.beforeEach( (to, from, next) => {
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
//   const isAuthenticated = firebase.auth().currentUser
//   console.log("RouteName", to.name)
//   console.log("requiresAuth",requiresAuth)
//   console.log("isAuthenticated",isAuthenticated)
//   if (requiresAuth && !isAuthenticated){
//     console.log("Authorized",store.getters.user.loggedIn)
//     router.push({ name: 'Signin' }).catch( () => {} )
//   } else {
//     next();
//   }
// })

// router.beforeEach(async (to, from, next) => {
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
//   console.log("requiresAuth",requiresAuth)
//   if (requiresAuth && !await store.getters.user.loggedIn){
//     console.log("Authorized",store.getters.user.loggedIn)
//     router.push({ name: 'Signin' }).catch( () => {} )
//   } else {
//     next();
//   }
// })

// router.beforeEach((to, from, next) => {
//   let isAuthenticated = store.getters.user.loggedIn
//   if (to.name !== 'Signin' && !isAuthenticated) next({ name:    'Signin' })
//   else next()
// })

// router.beforeEach((to, from, next) => {
//   let isAuthenticated = store.getters.user.loggedIn
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (!isAuthenticated) {
//       console.log("is not authenticated")
//       next({name: "Signin"})
//     } else {
//       console.log("is authenticated")
//       next()
//     }
//   } else {
//     console.log("does not require authentication")
//     next()
//   }
// })

export default router;
